export enum SortField {
  Date = 'Date',
  FormName = 'FormName',
  TraineeName = 'TraineeName',
  TrainerName = 'TrainerName',
  Status = 'Status',
  PhaseName = 'PhaseName'
}

export enum SortHighFivesField {
  CreatedAt = 'CreatedAt',
  Creator = 'CreatorName',
  Receiver = 'ReceiverName'
}
